import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { ActionFromPayloadMap, VisibilityFilter } from '../config/types';
import visibilityFilterReducer from '../reducers/visibilityFilters';

export type VisibilityFilterStateType = {
  visibilityFiltersKeyedById: Map<string, VisibilityFilter>
  isFetchingVisibilityFilters: boolean
  isCreatingNewVisibilityFilter: boolean
  isUpdatingVisibilityFilter: boolean
};

const initialState: VisibilityFilterStateType = {
  visibilityFiltersKeyedById: new Map(),
  isCreatingNewVisibilityFilter: false,
  isFetchingVisibilityFilters: false,
  isUpdatingVisibilityFilter: false,
};

export type VisibilityFilterActionPayloadMap = {
  SET_VISIBILITY_FILTER: Map<string, VisibilityFilter>;
  SET_FETCHING_VISIBILITY_FILTER: boolean;
  SET_CREATING_VISIBILITY_FILTER_LOADING: boolean;
  SET_UPDATING_VISIBILITY_FILTER_LOADING: boolean;
};

export type VisibilityFilterAction = ActionFromPayloadMap<VisibilityFilterActionPayloadMap>;

export const VisibilityFilterContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<VisibilityFilterAction>,
});

export const useVisibilityFilter = (): [
  VisibilityFilterStateType,
  React.Dispatch<VisibilityFilterAction>,
] => {
  const { state, dispatch } = useContext(VisibilityFilterContext);
  return [state, dispatch];
};

export const VisibilityFilterProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(visibilityFilterReducer, initialState);

  return (
    <VisibilityFilterContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </VisibilityFilterContext.Provider>
  );
};
